import React from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import Row from './Row';
import { balanceSelector } from '../../../../../../helpers/BankHelper';
import { useExchangeDesktopStyles } from './styles';

const ExchangeDesktop = ({ ...props }) => {
  const { rows, instructions, balance } = props;
  const classes = useExchangeDesktopStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.title}>
              <strong>Mis canjes realizados</strong>
            </TableCell>
            <TableCell className={classes.title}>
              <strong>Información</strong>
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <Row
              key={index}
              row={row}
              instructions={instructions}
              balance={balanceSelector(balance, row.productFolio)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

ExchangeDesktop.propTypes = {
  rows: PropTypes.array,
  instructions: PropTypes.array,
  balance: PropTypes.array,
};

export default ExchangeDesktop;
